import { Icons } from '@silverfort/sf-components';
import { TOWER_MENU_ITEMS, ROLES } from '@silverfort-nodelibs/common/utils/consts';

import { PricingModules, usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { getIsCloudMenuDisabled, isUserPermitted } from '../../../TowerMenu/TowerMenuUtils';
import { LogicalItemsTypes } from '../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { MenuItemContainer } from '../../../TowerMenu/logicalMenuItems/MenuItemContainer';

const NHI_MAIN_TITLE = 'Non Human Identities';
const ICON = Icons.ServiceAccountRobot;

export const NHILogicalMenuItems = ({
    handleMenuItemSelection,
    userData,
    getTowerMenuHref,
    ...props
}: LogicalItemsTypes) => {
    const { pricingModulesState } = usePricingModulesState();
    const isCloudResourcesEnabled = pricingModulesState?.[PricingModules.NHI_VISIBILITY]?.cloudEnabled || false;
    const onPremNHIEnabled = pricingModulesState?.[PricingModules.NHI_VISIBILITY]?.onPremEnabled;

    const hasOnPremPermission = isUserPermitted(userData, 'serviceAccounts', ROLES.VIEWER.value);
    const hasCloudPermission = isUserPermitted(userData, 'cloudNhi', ROLES.VIEWER.value);

    const isNHIEnabled = onPremNHIEnabled || isCloudResourcesEnabled;

    return (
        <MenuItemContainer
            {...props}
            parentId={TOWER_MENU_ITEMS.NHI}
            mainTitle={NHI_MAIN_TITLE}
            icon={ICON}
            userData={userData}
            showOnlyFirstItem={!isNHIEnabled}
            handleMenuItemSelection={handleMenuItemSelection}
            getTowerMenuHref={getTowerMenuHref}
            menuItems={[
                {
                    id: TOWER_MENU_ITEMS.NHI_AD,
                    title: 'Active Directory',
                    disabled: !hasOnPremPermission
                },
                {
                    id: TOWER_MENU_ITEMS.NHI_CLOUD,
                    title: 'Cloud',
                    disabled: getIsCloudMenuDisabled(isCloudResourcesEnabled, hasCloudPermission, hasOnPremPermission)
                }
            ]}
        />
    );
};
